module.exports = __webpack_public_path__ + "static/media/logo-retail24-sm.8a334f51.png";